import { createStore } from 'zustand'

import { CustomMemberGroupStore } from './interface'

export const createCustomMemberGroupStore = () =>
  createStore<CustomMemberGroupStore>((set, get) => ({
    disabled: undefined,
    value: [],
    onChange: undefined,

    currentGroup: undefined,
    setCurrentGroup: group => {
      set({ currentGroup: group })
    },

    formVisible: false,
    toggleFormVisible: () => {
      const formVisible = !get().formVisible
      set({ formVisible })
      if (!formVisible) {
        set({ currentGroup: undefined })
      }
    }
  }))
